export default "__VITE_ASSET__Bu40NGCD__"